<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="تقرير الموظف"
      :stringifyLongNum="true"
      :fetch="fetchData"
      :fields="json_fields"
      :header="[name, desc, `بطاقة الموظف`]"
    >
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  props: ["name", "desc", "month", "fullName"],
  data() {
    return {
      json_fields: {
        الإسم: "employeeName",
        "رقم الملف الشخصى": "profileNumber",
        "الرقم الوطنى": "nationalNumber",
        الجنس: "gender",
        "تاريخ الميلاد": {
          callback: (value) => {
            return this.convert_excel(value.birthDate);
          },
        },
        "رقم الهاتف": "phone",
        العنوان: "address",
        "الحالة الإجتماعية": "socialStatus",
        "البريد الإلكترونى": "email",
        "المؤهل العلمى": "scientificAppointment",
        التخصص: "specialization",
        "الادارة / المكتب": "departmentName",
        "القسم / المشروع": "sectionName",
        الوحدة: "unitName",
        "نوع التوظيف": "jobType",
        "الصفة التوظيفية": "jobDescription",
        "تاريخ المباشرة": {
          callback: (value) => {
            return this.convert_excel(value.jobDate);
          },
        },
        "رصيد الإجازات السنوى": "balanceDays",
        "رقم الملف المالى": "fileNumber",
        "المرتب الأساسى": "basicSalary",
        "رقم الضمان": "securityNumber",
        المصرف: "bankBranchName",
        "رقم الحساب": "accountNumber",
      },
    };
  },
  methods: {
    async fetchData() {
      // if (this.month == "1970-1-1") {
      //   return this.notifyVue(
      //     "top",
      //     "center",
      //     "danger",
      //     "عفواً، الرجاء ادخال من تاريخ الشهر"
      //   );
      // }
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(
        `${env.HR()}/api/hr/employeesReport/GetEmployeeCard?employeeId=${
          this.fullName
        }`,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      let data = [];

      data.push(res.data.data.items);

      return data;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },
    convert_excel(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return `${d.getFullYear()} - ${d.getMonth() + 1} - ${d.getDate()}`;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped></style>
